import { useQuery } from '@tanstack/react-query'
import { listAuditLog } from './api'

export const auditKeys = {
  list: (contractId: number, offset: number, limit: number) =>
    ['audit-log', contractId, offset, limit] as const,
}

export function useAuditLog(contractId: number, offset = 0, limit = 100) {
  return useQuery({
    queryKey: auditKeys.list(contractId, offset, limit),
    queryFn: () => listAuditLog(contractId, offset, limit),
    enabled: contractId > 0,
  })
}
